import {
  SET_INITIAL_SEARCH_PARAMS,
  SET_INITIAL_SEARCH_PARAM_DATES,
} from '../helpers/constants/actionsConstants';

import type {
  SetInitialSearchParamDatesAction,
  SetInitialSearchParamsAction,
} from './types';

const setInitialSearchParams = (
  originId: string,
  destinationId: string,
  destinationName: string,
  outboundMonth: number,
  outboundYear: number,
): SetInitialSearchParamsAction => ({
  type: SET_INITIAL_SEARCH_PARAMS,
  payload: {
    originId,
    destinationId,
    destinationName,
    outboundMonth,
    outboundYear,
  },
});

const setInitialSearchParamDates = (
  outboundMonth: number,
  outboundYear: number,
): SetInitialSearchParamDatesAction => ({
  type: SET_INITIAL_SEARCH_PARAM_DATES,
  payload: {
    outboundMonth,
    outboundYear,
  },
});

export { setInitialSearchParams, setInitialSearchParamDates };
